import { useStaffStore } from "../../stores/staff";

const UsersList = () => {
  const { users, idsUsers, setIdsUsers } = useStaffStore();

  const handleCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setIdsUsers(users.map((user) => user.id)); // Sélectionne tous les IDs
    } else {
      setIdsUsers([]); // Désélectionne tout
    }
  };

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    if (e.target.checked) {
      setIdsUsers([...idsUsers, id]); // Ajoute l'ID
    } else {
      setIdsUsers(idsUsers.filter((userId) => userId !== id)); // Supprime l'ID
    }
  };

  return (
    <div className="w-full h-2/3 border-2 border-light-blue bg-light-blue rounded-2xl overscroll-y-auto">
      <div className="flex items-center justify-start px-4 py-2 border-b border-light-blue">
        <input
          type="checkbox"
          className="mr-2"
          onChange={handleCheckAll}
          checked={idsUsers.length === users.length && users.length > 0}
        />

        <p>Tout cocher</p>
      </div>
      {users?.map((user) => (
        <div
          key={user.id}
          className="flex items-center justify-start px-4 py-2 border-b border-light-blue"
        >
          <input
            type="checkbox"
            name=""
            id={user.id.toString()}
            className="mr-2"
            checked={idsUsers.includes(user.id)} // Vérifie si l'ID est dans idsUsers
            onChange={(e) => handleCheck(e, user.id)}
          />
          <p>
            {user.firstName} {user.lastName}
          </p>
        </div>
      ))}
    </div>
  );
};

export default UsersList;
